import React, { type ReactNode } from 'react'
import { isFunction } from 'lodash-es'
import classnames from 'classnames'

import { TtIcon } from '@23/ui-react'

import './WebinarPanelComponent.scss'

interface WebinarPanelProps {
  icon?: { name: string; color: string }
  title?: string
  renderHeaderAction?: () => ReactNode
  className?: string
  isWithoutPadding?: boolean
}

const WebinarPanelComponent = ({
  icon,
  title,
  renderHeaderAction,
  className,
  isWithoutPadding = false,
  children,
}: React.PropsWithChildren<WebinarPanelProps>) => {
  return (
    <div
      className={classnames('webinar-panel-component', className)}
      style={{
        padding: isWithoutPadding ? '0px' : '12px',
      }}
    >
      {title && (
        <div className="header">
          <div className="left-wrapper">
            {icon && icon.name && (
              <TtIcon
                className="webinar-panel-icon"
                style={{ color: icon.color }}
                library="23"
                name={icon.name as HTMLTtIconElement['name']}
              />
            )}
            <span>{title}</span>
          </div>
          <div className="right-wrapper">
            {isFunction(renderHeaderAction) && renderHeaderAction()}
          </div>
        </div>
      )}
      {children}
    </div>
  )
}

export default WebinarPanelComponent
